import React from "react";
import { RxCross2 } from "react-icons/rx";
import { done } from "../../../resources/js/gifs";
import P from "../../../shared/typography/P";

const DonePage = ({ onClose = () => {}, showClose = true }) => {
    return (
        <div className="bg-white relative h-[100vh] mx-2 pt-[5rem] flex flex-col  items-center overflow-y-scroll">
            {showClose && (
                <div className="flex justify-end items-center text-lg w-full pr-1">
                    <div role="button" onClick={() => onClose()}>
                        <RxCross2 />
                    </div>
                </div>
            )}
            <img src={done} alt="done" />
            <P className="text-center">
                Thank you for accepting our proposal,we will reach out to you in
                next 24 hours
            </P>
        </div>
    );
};

export default DonePage;
